module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm._isColmo + 'icon-button',
    staticClass: "dof-icon-button weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "content weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.isShowTriangle) ? _c('div', {
    staticClass: "triangle weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "triangle-mask weex-ct weex-div",
    style: (_vm._px2rem(_vm.maskStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgBox weex-ct weex-div",
    style: (_vm._px2rem(_vm.style, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onClick($event)
      }
    }
  }, [(!_vm.isLoading && !_vm._iconFont.code) ? _c('figure', {
    staticClass: " weex-el weex-image",
    class: ['dof-icon-button-img', _vm.round && 'dof-icon-button-img--round'],
    style: (_vm._px2rem(_vm.imgStyle, 75)),
    attrs: {
      "src": _vm.src,
      "data-img-src": _vm.src,
      "weex-type": "image"
    }
  }) : (!_vm.isLoading && _vm._iconFont.code) ? _c('dof-iconfont', {
    attrs: {
      "code": _vm._iconFont.code,
      "size": _vm.imgSize - 10,
      "color": _vm._iconFont.color,
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.onClick
    }
  }) : _c('dof-spinner', {
    class: ['dof-icon-button-loading'],
    style: (_vm._px2rem(_vm.loadingImgStyle, 75)),
    attrs: {
      "type": _vm.loadingSrc
    }
  })], 1)]), _vm._v(" "), _vm._t("default", [(_vm.text) ? _c('p', {
    staticClass: "dof-icon-button-text weex-el weex-text",
    style: ({
      color: _vm._textColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()], {})], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1016c17e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1016c17e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-icon-button/index.vue
// module id = 565
// module chunks = 0 1